import React, { useState, useEffect } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebase/Firebase';

const Table = ({ collectionName, headers, orgId, onDelete }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    let dataQuery;

    if (orgId) {
      dataQuery = query(collection(db, collectionName), where("orgId", "==", orgId));
    } else {
      dataQuery = collection(db, collectionName);
    }

    const unsubscribe = onSnapshot(dataQuery, (snapshot) => {
      const dataArray = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setData(dataArray);
    });

    return () => unsubscribe();
  }, [collectionName, orgId]);

  if (!data.length) return <p>No data found.</p>;

  return (
    <table style={{ width: '100%', border: '1px solid gray', borderCollapse: 'collapse', borderRadius: '8px', textAlign: 'left' }}>
      <thead style={{ borderRadius: '8px' }}>
      <tr style={{ borderRadius: '8px' }}>
        {headers?.map((headerObj) => (
          <th key={headerObj.key} style={{
            padding: '8px',
            borderTop: '1px solid gray',
            borderRadius: '8px',
          }}>
            {headerObj.label}
          </th>
        ))}
      </tr>
      </thead>
      <tbody style={{ borderRadius: '8px' }}>
      {data?.map((item, rowIndex) => (
        <tr key={rowIndex}>
          {headers?.map((headerObj) => (
            <td key={headerObj.key} style={{
              padding: '8px',
              borderTop: '1px solid gray',
              borderRadius: '8px',
            }}>
              {item[headerObj.key]}
            </td>
          ))}
          <td style={{ padding: '8px', borderTop: '1px solid gray', borderRadius: '8px', }}>
            {onDelete && <button style={{ height: 35, wdith: 50, backgroundColor: '#FFC300', fontWeight: 'bold', border: '1px solid white', borderRadius: '8px'}} onClick={() => onDelete(item)}>Delete</button>}
          </td>
        </tr>
      ))}
      </tbody>
    </table>
  );
}


export default Table;
